import { login, logout, getInfo } from '@/api/common'
import {
  clearDingPasswordRequired,
  clearUserSessionStorage,
  getToken,
  removeToken,
  setDingPasswordRequired,
  setToken
} from '@/utils/auth'

function createLoginError(response) {
  const error = new Error((response && response.message) || '登录失败')
  error.code = response && response.code
  error.responseData = response
  return error
}

function clearLocalSession(commit, preserveRedirect = false) {
  removeToken()
  clearUserSessionStorage(preserveRedirect)
  commit('RESET_STATE')
}
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    userInfo: {},
    loginUserId: null
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_LOGINUSERID: (state, loginUserId) => {
    state.loginUserId = loginUserId
  }
}

const actions = {
  // 用户登录
  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const credentials = payload.credentials
      const loginMethod = payload.loginMethod

      login(credentials)
        .then(response => {
          if (
            !response ||
            response.code !== 200 ||
            !response.data ||
            !response.data.access_token
          ) {
            reject(createLoginError(response))
            return
          }

          const { data } = response
          setToken(data.access_token, data.expires_in)
          commit('SET_TOKEN', data.access_token)
          if (loginMethod === 'password') {
            clearDingPasswordRequired()
          }
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          const { data } = response

          if (!data) {
            reject('Verification failed, please Login again.')
          }

          const { realname, img, thumb_img } = data
          localStorage.setItem('loginUserInfo', JSON.stringify(response.data))
          commit('SET_USERINFO', response.data)
          commit('SET_NAME', realname)
          commit('SET_AVATAR', img || thumb_img)
          commit('SET_LOGINUSERID', data.id)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 退出登录
  logout({ commit, state }) {
    return logout(state.token)
      .then(response => {
        if (!response || response.code !== 200) {
          return Promise.reject(createLoginError(response))
        }
        return response
      })
      .finally(() => {
        // 后端退出失败也必须结束本地会话，避免失效 token 和钉钉免登状态残留。
        setDingPasswordRequired()
        clearLocalSession(commit)
      })
  },

  // 清除token
  resetToken({ commit }, options = {}) {
    return new Promise(resolve => {
      if (options.requirePassword) {
        setDingPasswordRequired()
      }
      clearLocalSession(commit, Boolean(options.preserveRedirect))
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
